import { ReactNode } from 'react'
import { FlashMessage } from './FlashMessage'

interface LayoutProps {
  children: ReactNode
}

export default function Layout({ children }: LayoutProps) {
  return (
    <>
      <FlashMessage />
      <main>{children}</main>
    </>
  )
}
